import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getOrigenesEntradaMercancia`, method: 'GET', body: null, token: token})
}